import {Doughnut} from 'react-chartjs-2';

import {Grid, Typography} from '@mui/material';

import {greenColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  percentage: number;
}

export const CultureFit = ({percentage}: Props) => {
  const data = {
    datasets: [
      {
        data: [100 - percentage, percentage],
        backgroundColor: [greenColors[40], greenColors[500]],
        borderWidth: 0,
      },
    ],
  };
  return (
    <Grid container justifyContent='flext-start' alignItems='center' minWidth='80px' gap='8px'>
      <Grid width='24px'>
        <Doughnut
          data={data}
          options={{
            animation: false,
            plugins: {
              tooltip: {enabled: false},
              legend: {display: false},
              datalabels: {
                display: false,
              },
            },
          }}
        />
      </Grid>
      <Typography marginLeft='2px' variant='body2'>{`${percentage}%`}</Typography>
    </Grid>
  );
};
